/**
 * The subscription flags the rest of the app reads from `state.global.subscriptionInfo`.
 *
 * The backend resolves ONE active subscription and never falls back to an expired one.
 * With none active: `subscription` is null, `has_active_subscription` is false and
 * `last_subscription` is the most recent row ({package_title, status, end_date}) or null.
 *
 * isFinished (drives the "subscription expired" toast and the redirect to billing) uses the
 * SAME end_date test as always, read from whichever of `subscription` / `last_subscription`
 * is present, so an expired, inactive or cancelled company behaves exactly as before.
 * noActivePlan is the new "never had a plan" state (no toast saying "expired").
 */
export function subscriptionInfoFromDetails(details, now = new Date()) {
    const lastKnown = details?.subscription ?? details?.last_subscription;

    return {
        isProPackage: details?.package?.title?.toLowerCase() === "professional",
        isFinished: now > new Date(lastKnown?.end_date),
        noActivePlan: details?.has_active_subscription === false && !details?.last_subscription,
        isYearly: details?.subscription?.period === "ONE_YEAR",
        isFree: details?.package?.is_free === 1,
    };
}
